// Client-name → published case-study slug. Used by shared CaseCTA + card
// wrappers to auto-link case blocks across the site. Any name not in the
// map falls back to "Case page coming soon".
//
// Slugs match /work/$slug routes and Sanity `caseStudy.slug.current`.

const MAP: Array<{ match: RegExp; slug: string }> = [
  { match: /energy safety canada|\besc\b/i, slug: "energy-safety-canada-member-experience" },
  { match: /american medical|ama\b|\bfreida\b/i, slug: "transformation-ama-digital-platform" },

  { match: /kohler/i, slug: "transforming-digital-experience-of-kohler" },
  { match: /ironman/i, slug: "transforming-digital-experience-of-ironman" },
  { match: /university of east london|\buel\b/i, slug: "dxp-for-university-of-east-london" },
  { match: /ohchr|un human rights|united nations human rights/i, slug: "transforming-digital-experience-content-publishing-for-ohchr" },
  { match: /idmc|internal displacement/i, slug: "elevating-idmc-user-experience" },
  { match: /\bwrap\b/i, slug: "modernizing-wrap-website-for-global-audience" },
  { match: /real-?time (betting|sports)|betting platform|fantasy sports/i, slug: "engineering-a-real-time-betting-platform" },
  { match: /whatsapp/i, slug: "streamlining-sales-ops-by-auto-syncing-whatsapp-conversations-in-hubspot" },
  { match: /suny maritime|state university of new york,? maritime/i, slug: "suny-maritime-college-drupal-migration" },
  { match: /union ?coop/i, slug: "union-coop-digital-asset-transformation" },
  { match: /race ?forward/i, slug: "race-forward-multi-site-drupal-migration" },




];

export function caseSlugForClient(name?: string | null): string | null {
  if (!name) return null;
  for (const entry of MAP) {
    if (entry.match.test(name)) return entry.slug;
  }
  return null;
}
